module.exports = __webpack_public_path__ + "img/type2.23f4893d.png";